// extracted by mini-css-extract-plugin
export default {"container":"Testimonials_container__A0eOC","dots1":"Testimonials_dots1__JG6m1","dots2":"Testimonials_dots2__lr8XS"};